function HandleIcon() {
    return (
        <svg width="21" height="16" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H22" stroke="#6E6864" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1 9H22" stroke="#6E6864" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1 17H22" stroke="#6E6864" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default HandleIcon;
